module.exports = __webpack_public_path__ + "static/media/closeIcon.171f002e.svg";